import { useState, useRef } from "react";
import { FormRow, FormRowSelect, FormRowSelectId, NavLinkButton } from "../";
import Wrapper from "../../assets/wrappers/DashboardFormPage";
import {
  Form,
  useSubmit,
  useLocation,
  useOutletContext,
} from "react-router-dom";
import {
  YES_NO_ALL,
  SCREEN_TYPE,
  SCHEDULE_SORT_BY,
} from "../../../../utils/constants.js";
import { toast } from "react-toastify";
import { useAllSchedulesContext } from "../../pages/AllCampaignSchedules";
import { Loading } from "../../components";
import { TbReport } from "react-icons/tb";
import { customFetch } from "../../utils/custom-fetch";
const ScheduleSearchContainer = () => {
  const submit = useSubmit();
  const { user } = useOutletContext();
  const { maintenanceCompanies } = useAllSchedulesContext();
  const { search } = useLocation();
  const qs = new URLSearchParams(search);

  const [loading, setLoading] = useState(false);

  // useRef לשמירת timeout בין קריאות
  const debounceTimeout = useRef(null);

  // useRef להפניה ל־<Form> (למקרה של קריאה ישירה)
  const formRef = useRef(null);

  // Debounce לשדה החיפוש (search) – 1100ms
  const handleSearchChange = (e) => {
    const formElement = e.currentTarget.form;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      setLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // ניתן להוסיף טיפול בשגיאה במידת הצורך
      } finally {
        setLoading(false);
      }
    }, 1500);
  };

  const handleDownloadReport = async () => {
    try {
      const response = await customFetch.get("/campaign-schedules/report", {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "campaign_report.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("הדוח נוצר בהצלחה");
    } catch (err) {
      toast.error("שגיאה בהורדת הדוח");
    }
  };

  // Debounce לשאר השדות (select) – 100ms
  const handleSelectChange = (e) => {
    let formElement;

    if (e && e.target) {
      formElement = e.currentTarget.form;
    } else {
      formElement = formRef.current;
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      setLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // טיפול בשגיאה אם צריך
      } finally {
        setLoading(false);
      }
    }, 100);
  };

  return (
    <Wrapper>
      {/* משייכים ref ל־Form */}
      <Form className="form" ref={formRef}>
        <h5 className="form-title">חיפוש תזמון קמפיין</h5>
        {loading && <Loading />}

        <div className="form-center">
          {/* 1. שדה חיפוש טקסטואלי */}
          <FormRow
            name="search"
            type="search"
            labelText="חיפוש"
            placeholder="קמפיין / כתובת"
            defaultValue={qs.get("search") || ""}
            handleChange={handleSearchChange}
          />

          {/* 2. סוג מסך */}
          <FormRowSelect
            name="screenType"
            labelText="סוג מסך"
            list={["הכל", ...Object.values(SCREEN_TYPE)]}
            defaultValue={qs.get("screenType") || "all"}
            handleChange={handleSelectChange}
          />

          {/* 3. מצב הקמפיין */}
          <FormRowSelect
            name="status"
            labelText="מצב הקמפיין"
            list={["הכל", "פעיל", "הסתיים", "עתידי"]}
            defaultValue={qs.get("status") || "all"}
            handleChange={handleSelectChange}
          />

          {/* 4. גלובלי? */}
          <FormRowSelect
            name="isGlobal"
            labelText="גלובלי?"
            list={YES_NO_ALL}
            defaultValue={qs.get("isGlobal") || "all"}
            handleChange={handleSelectChange}
          />

          {/* 5. מיון */}
          <FormRowSelect
            name="sort"
            labelText="מיון לפי"
            list={Object.values(SCHEDULE_SORT_BY)}
            defaultValue={qs.get("sort") || "newest"}
            handleChange={handleSelectChange}
          />

          {/* 6. חברת אחזקה (admin בלבד) */}
          {user.role === "admin" && (
            <FormRowSelectId
              name="maintenanceCompany"
              labelText="חברת אחזקה"
              list={maintenanceCompanies}
              idField="_id"
              displayField="name"
              defaultValue={qs.get("maintenanceCompany") || "הכל"}
              handleChange={handleSelectChange}
            />
          )}

          {/* 7. כפתור ניקוי סינון */}
          <NavLinkButton
            text="ניקוי סינון"
            path="/dashboard/all-schedules"
            icon="clear"
            color="#758694"
          />

          <button
            type="button"
            className="btn btn-report"
            style={buttonStyle}
            onClick={handleDownloadReport}
          >
            <TbReport size={20} />
          </button>
        </div>
      </Form>
    </Wrapper>
  );
};

const buttonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  // width: "40px",
  height: "40px",
  backgroundColor: "#f0f0f0",
  borderRadius: "5px",
  color: "#333",
  textDecoration: "none",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
};

export default ScheduleSearchContainer;
